function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #191915;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M48.14,0H1.86C.79,0,0,.86,0,1.86v46.28c0,1.07.86,1.86,1.86,1.86h46.28c1.07,0,1.86-.86,1.86-1.86V1.86C50,.79,49.14,0,48.14,0ZM49,48.14c0,.42-.32.86-.86.86H1.86c-.42,0-.86-.32-.86-.86V1.86c0-.42.32-.86.86-.86h46.28c.42,0,.86.32.86.86v46.28Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M38.58,25.38c-.21,0-.39.17-.39.39v10.23c0,.82-.67,1.49-1.49,1.49H14.31c-.82,0-1.49-.67-1.49-1.49V13.59c0-.82.67-1.49,1.49-1.49h10.21c.21,0,.39-.17.39-.39s-.17-.39-.39-.39h-10.21c-1.25,0-2.26,1.01-2.26,2.26v22.4c0,1.25,1.01,2.26,2.26,2.26h22.4c1.25,0,2.26-1.01,2.26-2.26v-10.23c0-.21-.17-.39-.39-.39v.02Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M36.71,10.95h-9.92c-.43,0-.77.34-.77.77s.34.77.77.77h9.92c.61,0,1.1.49,1.1,1.1v9.94c0,.43.34.77.77.77s.77-.34.77-.77v-9.94c0-1.46-1.19-2.64-2.64-2.64Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M34.59,26.3c.16,0,.23-.01.31-.06.1-.07.15-.17.15-.29s-.06-.23-.16-.3c-.08-.05-.15-.06-.3-.06h-2.69c-.1,0-.24,0-.34.11-.11.11-.11.24-.11.34v4.74c0,.1,0,.24.11.34.11.11.24.11.34.11h2.69c.16,0,.23-.01.31-.06.1-.07.15-.17.15-.29s-.06-.23-.16-.3c-.08-.05-.15-.06-.3-.06h-2.36v-1.77h1.95c.16,0,.23-.01.31-.06.1-.07.15-.17.15-.29s-.06-.23-.16-.3c-.08-.05-.14-.06-.3-.06h-1.95v-1.73h2.36,0Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M25.74,31.26c.14,0,.26-.06.32-.17.06-.1.07-.17.07-.33v-3.3l1.22,2.63c.08.16.19.33.43.33s.35-.17.43-.33l1.22-2.63v3.3c0,.16,0,.23.07.33s.19.17.32.17.26-.06.32-.17c.06-.1.07-.17.07-.33v-4.74c0-.11-.01-.25-.12-.35-.07-.08-.17-.12-.28-.12-.09,0-.16.02-.23.06-.07.04-.14.12-.19.24l-1.61,3.48-1.61-3.48c-.06-.12-.12-.2-.19-.24-.07-.04-.14-.06-.23-.06-.11,0-.21.04-.28.12-.11.11-.12.25-.12.36v4.74c0,.16,0,.23.07.33s.19.17.32.17h0Z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M22.31,31.27c.56,0,1.06-.19,1.43-.56.56-.56.58-1.08.58-2.3s-.02-1.75-.58-2.3c-.37-.37-.87-.56-1.43-.56s-1.06.19-1.43.56c-.56.56-.58,1.08-.58,2.3s.02,1.75.58,2.3c.37.37.87.56,1.43.56ZM21.44,26.61c.23-.24.53-.36.87-.36s.64.12.87.36c.31.32.36.67.36,1.79s-.04,1.47-.36,1.79c-.23.24-.53.36-.87.36s-.64-.12-.87-.36c-.31-.32-.36-.67-.36-1.79s.04-1.47.36-1.79Z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M18.56,31.09c.07.1.19.17.32.17s.26-.06.32-.17c.06-.1.07-.17.07-.33v-4.72c0-.16,0-.23-.07-.33s-.19-.17-.32-.17-.26.06-.32.17c-.06.1-.07.17-.07.33v1.98h-2.38v-1.98c0-.16,0-.23-.07-.33s-.19-.17-.32-.17-.26.06-.32.17c-.06.1-.07.17-.07.33v4.72c0,.16,0,.23.07.33s.19.17.32.17.26-.06.32-.17c.06-.1.07-.17.07-.33v-2.02h2.38v2.02c0,.16,0,.23.07.33Z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M25.8,24.03c.14,0,.26-.06.32-.17.06-.1.07-.17.07-.33v-3.66l2.62,3.87c.1.14.21.28.41.28.11,0,.21-.04.29-.12.08-.08.12-.19.12-.36v-4.73c0-.15,0-.23-.07-.33s-.19-.17-.32-.17-.26.06-.32.17c-.06.1-.07.18-.07.33v3.66l-2.62-3.87c-.09-.13-.21-.27-.41-.27-.11,0-.22.04-.29.12-.08.08-.12.19-.12.36v4.73c0,.16,0,.23.07.33s.19.17.32.17h0Z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M32.97,19.03c.55,0,.95.29,1.13.85.05.14.1.23.16.29.06.06.15.09.24.09.1,0,.19-.04.26-.1.07-.07.1-.16.1-.28,0-.2-.13-.56-.37-.85-.38-.46-.88-.69-1.54-.69-.57,0-1.06.2-1.42.56-.54.54-.58,1.01-.58,2.3s.02,1.75.58,2.3c.37.37.87.56,1.43.56s1.04-.19,1.42-.57c.49-.49.57-.97.57-1.94v-.1c0-.1,0-.24-.11-.34s-.24-.11-.34-.11h-1.22c-.16,0-.23.01-.31.06-.1.07-.15.17-.15.29s.06.23.16.3c.08.05.14.06.3.06h.91c0,.73-.09,1.03-.35,1.29-.23.23-.53.35-.88.35s-.64-.12-.87-.36c-.31-.32-.36-.67-.36-1.79s.04-1.48.36-1.79c.23-.24.52-.36.86-.36l.02-.02Z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M16.75,24.05c1.08,0,1.8-.72,1.8-1.8v-3.43c0-.16,0-.23-.07-.33s-.19-.17-.32-.17-.26.06-.32.17c-.06.1-.07.17-.07.33v3.35c0,.75-.36,1.16-1.02,1.16-.26,0-.43-.05-.62-.19-.13-.09-.22-.13-.32-.13s-.18.04-.25.11c-.06.07-.09.15-.09.25,0,.17.1.26.19.33.31.23.66.34,1.09.34h0Z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M20.65,18.5c-.07-.1-.19-.17-.32-.17s-.26.06-.32.17c-.06.1-.07.17-.07.33v3.28c0,1.12.84,1.94,2,1.94s2.01-.82,2.01-1.94v-3.28c0-.16,0-.23-.07-.33s-.19-.17-.32-.17-.26.06-.32.17c-.06.1-.07.18-.07.33v3.24c0,.77-.48,1.27-1.23,1.27s-1.22-.5-1.22-1.27v-3.24c0-.16,0-.23-.07-.33Z"
});

function SvgJungQuelleHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJungQuelleHome);
export default __webpack_public_path__ + "static/media/jung_quelle_home.29642a8298718aa3729666219e95698e.svg";
export { ForwardRef as ReactComponent };